import { render, staticRenderFns } from "./basecopyRight.vue?vue&type=template&id=e149ed58"
import script from "./basecopyRight.vue?vue&type=script&lang=js"
export * from "./basecopyRight.vue?vue&type=script&lang=js"
import style0 from "./basecopyRight.vue?vue&type=style&index=0&id=e149ed58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports